<div class="modal-header" style="font-weight: 700; font-size: 1.2rem">
  Message to send:
</div>
<div class="modal-body">
  <textarea
    rows="100"
    placeholder="Type the message here"
    name="message"
    [(ngModel)]="message"
    class="form-control chat-input"
  ></textarea>
</div>
<div class="modal-footer">
  <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
    Cancel
  </div>
  <div
    class="btn btn-primary"
    style="margin-left: auto"
    aria-label="Send"
    (click)="confirm()"
  >
    Send
  </div>
</div>
